import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Api from "../Auth/Api";
import { Modal, Toast, Offcanvas, Form } from "react-bootstrap";
import DropdownMenu from '../Components/DropdownMenu';
import { useForm, Controller } from "react-hook-form";
import Select from 'react-select';
import { PDFDownloadLink } from '@react-pdf/renderer';
import GerarPDF from "../Components/GerarPDF";
import { decodeJWT, truncateString } from '../Components/jwtUtils';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import TextareaAutosize from "react-textarea-autosize";
import TableUsuariosProvas from "../Components/TableUsuariosProvas";
import QRCode from 'qrcode.react';
import ModalAvaliacaoReacao from "../Components/ModalAvaliacaoReacao";
import { customStyles } from '../utils/selectStyles';
import { ModuleBannerSkeleton, AulaSkeletons } from '../Components/Skeletons/AulaSkeleton';
import AulasManager from '../Components/Dashboard/Aulas/AulasManager';

function Aulas() {

    const navigate = useNavigate();
    const { id } = useParams();
    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivel = decodeJWT(token).nivel;
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [loadingModulo, setLoadingModulo] = useState(true);
    const [dataInfoModulo, setDataInfoModulo] = useState([]);
    const [loadingAulas, setLoadingAulas] = useState(true);
    const [dataAulas, setDataAulas] = useState([]);
    const [showModalMinhasNotas, setShowModalMinhasNotas] = useState(false);
    const [showModalAtividadeExtra, setShowModalAtividadeExtra] = useState(false);
    const [showModalEditarAula, setShowModalEditarAula] = useState(false);
    const [file0Selected, setFile0Selected] = useState(false);
    const [file1Selected, setFile1Selected] = useState(false);
    const [file2Selected, setFile2Selected] = useState(false);
    const [uploadAulaProgress, setUploadAulaProgress] = useState(0);
    /** Editar aula: false = arquivo | true = URL externa (html_externo) */
    const [editAulaUrlExterna, setEditAulaUrlExterna] = useState(false);
    const [isLoadingEditarAula, setIsLoadingEditarAula] = useState(false);
    const [showModalDeletar, setShowModalDeletar] = useState(false);
    const [deletarAula, setDeletarAula] = useState([]);
    const [showModalAtribuirNotas, setShowModalAtribuirNotas] = useState(false);
    const [showModalAlunosComNotas, setShowModalAlunosComNotas] = useState(false);
    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [filteredUsuarios, setFilteredUsuarios] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [notas, setNotas] = useState({});
    const { register, handleSubmit, control, setValue, reset, formState: { errors } } = useForm();
    const [alternatives, setAlternatives] = useState([]);
    const [selectedQuestao, setSelectedQuestao] = useState(null);
    const [qrCodeData, setQrCodeData] = useState('');
    const [showModalQrCode, setShowModalQrCode] = useState(false);
    const [arquivos, setArquivos] = useState({});
    const [todosArquivosEnviados, setTodosArquivosEnviados] = useState(false);
    const [showModalFinalGrupo, setShowModalFinalGrupo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalTemAvaliacao, setModalTemAvaliacao] = useState(false);
    const [certificadoStatus, setCertificadoStatus] = useState(null);
    const [certificadoChecked, setCertificadoChecked] = useState(false);
    const statusAvaliacao = checkStatusAvaliacao(dataInfoModulo);
    const [avaliacaoReacaoStatus, setAvaliacaoReacaoStatus] = useState(null);
    const [modalTemAvaliacaoReacao, setModalTemAvaliacaoReacao] = useState(false);
    const [modalVerAvaliacaoReacao, setModalVerAvaliacaoReacao] = useState({ show: false, data: null });
    const [avaliacaoReacaoHibridoStatus, setAvaliacaoReacaoHibridoStatus] = useState(null);
    const [modalTemAvaliacaoReacaoHibrido, setModalTemAvaliacaoReacaoHibrido] = useState(false);
    const [showDrawerMobile, setShowDrawerMobile] = useState(false);

    // Verificar status da avaliação de reação
    useEffect(() => {
        async function verificarStatusAvaliacaoReacao() {
            if (!dataInfoModulo[0] || nivel === 'Administrador') {
                return;
            }

            try {
                const response = await Api.get(`api/verificar-status-avaliacao-reacao/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setAvaliacaoReacaoStatus(response.data);

                if (
                    response.data.avaliacao_normal_concluida &&
                    !response.data.avaliacao_reacao_concluida &&
                    statusAvaliacao === 'Avaliação concluída' &&
                    response.data.precisa_avaliacao_reacao &&
                    !response.data.certificado_liberado
                ) {
                    setTimeout(() => {
                        setModalTemAvaliacaoReacao(true);
                    }, 3000);
                }
            } catch (error) {
                console.error("Erro ao verificar status da avaliação de reação:", error);
            }
        }

        if (dataInfoModulo[0]) {
            verificarStatusAvaliacaoReacao();
        }
    }, [dataInfoModulo, token, nivel, id, statusAvaliacao]);

    // Adicionar useEffect para verificar status da avaliação de reação híbrida
    useEffect(() => {
        async function verificarStatusAvaliacaoReacaoHibrido() {
            if (!dataInfoModulo[0] || nivel === 'Administrador') {
                return;
            }

            try {
                const response = await Api.get(`api/verificar-status-avaliacao-reacao-hibrido/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setAvaliacaoReacaoHibridoStatus(response.data);

                if (
                    response.data.tipo_curso === 'misto' &&
                    response.data.avaliacao_normal_concluida &&
                    response.data.pratica_concluida &&
                    !response.data.avaliacao_reacao_hibrido_concluida &&
                    response.data.pode_responder_avaliacao_reacao_hibrido &&
                    statusAvaliacao === 'Avaliação concluída' &&
                    !response.data.certificado_liberado
                ) {
                    setTimeout(() => {
                        setModalTemAvaliacaoReacaoHibrido(true);
                    }, 3000);
                }
            } catch (error) {
                console.error("Erro ao verificar status da avaliação de reação híbrida:", error);
            }
        }

        if (dataInfoModulo[0]) {
            verificarStatusAvaliacaoReacaoHibrido();
        }
    }, [dataInfoModulo, token, nivel, id, statusAvaliacao]);

    // Verificar status do certificado para este curso/módulo
    useEffect(() => {
        async function verificarStatusCertificado() {
            if (!dataInfoModulo[0] || nivel === 'Administrador') {
                setCertificadoChecked(true);
                return;
            }

            try {
                if (!dataInfoModulo || !dataInfoModulo[0] || !dataInfoModulo[0].idCurso) return;
                const idCurso = dataInfoModulo[0].idCurso;
                const response = await Api.get(`api/verificar-status-certificado-curso/${idCurso}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                setCertificadoStatus(response.data);
                setCertificadoChecked(true);
            } catch (error) {
                console.error("Erro ao verificar status do certificado:", error);
                setCertificadoChecked(true);
            }
        }

        if (dataInfoModulo[0]) {
            verificarStatusCertificado();
        }
    }, [dataInfoModulo, token, nivel]);

    // Verificar se o usuário pode ver o PDF da prova
    const podeVerPdfProva = useCallback(() => {
        // Admins, RH sempre podem ver
        if (nivel === 'Administrador' || nivel === 'RH') {
            return true;
        }

        // Se não verificamos o certificado ainda, não permitir
        if (!certificadoChecked) {
            return false;
        }

        // Se não temos dados do certificado, não permitir
        if (!certificadoStatus) {
            return false;
        }

        // Se o certificado estiver expirado, não permitir
        if (certificadoStatus.certificado_expirado) {
            return false;
        }

        // Curso liberado para reciclagem, ou prestes a ser (dentro da janela antes do vencimento)
        if (certificadoStatus.reciclagem_liberada || certificadoStatus.dentro_janela_reciclagem) {
            return false;
        }

        // Se chegou até aqui, o certificado está válido e fora da janela de reciclagem
        return true;
    }, [nivel, certificadoChecked, certificadoStatus]);

    ////// Inicio Avaliação P1

    const [showModalAvaliacao, setShowModalAvaliacao] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [cursoEditarFile, setCursoEditarFile] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [reloadQuestoes, setReloadQuestoes] = useState(false);
    const [correctAnswer, setCorrectAnswer] = useState('');
    const [progressoAvaliacao, setProgressoAvaliacao] = useState('');
    const [dataQuestoes, setDataQuestoes] = useState([]);
    const [isCreating, setIsCreating] = useState(false);
    const [showModalDeletarQuestao, setShowModalDeletarQuestao] = useState(false);
    const [questaoParaDeletar, setQuestaoParaDeletar] = useState(null);

    const handleCreateNewQuestion = () => {
        setSelectedQuestao(null);
        setIsCreating(true); // Entre no modo de criação
        setAlternatives([]); // Limpa a lista de alternativas
        setValue("questao", ''); // Limpe o campo de questão
        setValue("resposta", ''); // Limpe a resposta correta
        setValue("imagem", '');
        setCursoEditarFile(false);
        setPreviewUrl(null);
        setCorrectAnswer('');
        setSelectedValue(null);
        for (let index = 0; index < 10; index++) {
            setValue(`alternativa_${index}`, '');
        }
        async function fetchData() {
            try {
                const response = await Api.get(`api/configuracao-avaliacao/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setValue("data_disponibilidade", response.data[0].data_disponibilidade);
                setValue("data_disponibilidade_fim", response.data[0].data_disponibilidade_fim);
                setValue("tempo", response.data[0].tempo);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    };

    function checkStatusAvaliacao(dataInfoModulo) {
        if (!dataInfoModulo || dataInfoModulo.length === 0) {
            return "Avaliação indisponível";
        }

        if (!dataInfoModulo[0] || !dataInfoModulo[0].avaliacao_p1) {
            return "Avaliação indisponível";
        }
        const { porcentagem, disponivel, avaliacao_status } = dataInfoModulo[0].avaliacao_p1;

        // Se o modulo foi completado (porcentagem === 100)
        if (porcentagem === 100 && nivel !== 'Administrador') {
            // Se a avaliação está disponível para ser feita
            if (disponivel === 1 && avaliacao_status === 0) {
                return "Fazer avaliação";
            }
            // Se a avaliação já foi feita e concluída com sucesso
            if (avaliacao_status === 1) {
                return "Avaliação concluída";
            }
        }

        // Caso a avaliação não esteja disponível ou completa
        return "Avaliação indisponível";
    }

    // Buscar questoes
    useEffect(() => {
        setDataQuestoes([]); // Limpa a questão antes de ler a api
        async function fetchData() {
            try {
                const response = await Api.get(`api/questoes/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setDataQuestoes(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        nivel === 'Administrador' && fetchData();
    }, [token, id, reloadQuestoes, nivel]);

    // O que faz quando uma questão é selecionada
    useEffect(() => {
        if (selectedQuestao) {
            setAlternatives(JSON.parse(selectedQuestao.alternativas));
            // Use setValue para definir a alternativa correta
            setValue("resposta", selectedQuestao.resposta ? parseInt(selectedQuestao.resposta) : '');
        }
    }, [selectedQuestao, setValue, dataQuestoes]);

    const addAlternative = () => {
        setAlternatives([...alternatives, '']);
    };

    // Atualize a função removeAlternative para manter a resposta correta atualizada
    const removeAlternative = (index) => {
        const updatedAlternatives = [...alternatives];
        updatedAlternatives.splice(index, 1);
        setAlternatives(updatedAlternatives);
        setValue(`alternativa_${index}`, '');

        // Atualize a resposta correta se a alternativa removida for a correta
        if (index + 1 === correctAnswer) {
            setCorrectAnswer('');
        }
    };

    // Atualize setSelectedValues para definir o valor correto para correctAnswer
    const setSelectedValues = useCallback((selected) => {
        setValue("questao", selected.questao);
        setAlternatives(JSON.parse(selected.alternativas));
        setCorrectAnswer(selected.resposta ? parseInt(selected.resposta) : '');
    }, [setValue]);

    useEffect(() => {
        if (selectedQuestao) {
            setSelectedValues(selectedQuestao);
            setAlternatives(JSON.parse(selectedQuestao.alternativas));
            JSON.parse(selectedQuestao.alternativas).forEach((alt, index) => {
                setValue(`alternativa_${index}`, alt);
            });
        }
    }, [selectedQuestao, setSelectedValues, setValue]);

    const onSubmit = async (data) => {

        const alternativas = alternatives.map((_, index) => data[`alternativa_${index}`]);
        const resultJson = {
            questao: data.questao,
            alternativas: JSON.stringify(alternativas),
            resposta: data.resposta.toString(),
            tempo: data.tempo,
            data_disponibilidade: data.data_disponibilidade,
            data_disponibilidade_fim: data.data_disponibilidade_fim,
            imagem: data.imagem,
            idModulo: id
        };

        const formData = new FormData();

        Object.keys(resultJson).forEach(key => {
            const value = resultJson[key];  // Use resultJson aqui
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file);
                });
            } else {
                formData.append(key, value);
            }
        });

        // function logFormData(fd) {
        //     for (let pair of fd.entries()) {
        //         console.log(pair[0] + ': ' + pair[1]);
        //     }
        // }

        // logFormData(formData);


        if (isCreating) {
            // Lógica para criar uma nova questão
            try {
                const response = await Api.post(`api/criar-questao/${id}`, formData, { headers: { Authorization: `Bearer ${token}` } });
                setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' });
            } catch (error) {
                setToast({ header: 'Erro!', body: error.response.data.message, type: 'toast-error' });
                console.log(error);
            }

        } else {
            // Lógica para editar uma questão existente
            try {
                const response = await Api.post(`api/editar-questao/${selectedQuestao.id}`, formData, { headers: { Authorization: `Bearer ${token}` } });
                setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' });
            } catch (error) {
                setToast({ header: 'Erro!', body: error.response.data.message, type: 'toast-error' });
                console.log(error);
            }
        }

        setShowToast(true);
        setPreviewUrl(null);
        setReloadQuestoes(prevState => !prevState)
        setSelectedQuestao(null);
        setIsCreating(false);
        setAlternatives([]); // Limpa a lista de alternativas
        setValue("imagem", '');
        setValue("questao", ''); // Limpe o campo de questão
        setValue("resposta", ''); // Limpe a resposta correta
        setCorrectAnswer(''); // Limpa questao correta
        setSelectedValue(null); // Limpe o valor selecionado
        for (let index = 0; index < 20; index++) {
            setValue(`alternativa_${index}`, '');
        }
    };

    const {
        register: register_A,
        handleSubmit: handleSubmit_A,
        control: control_A,
        setValue: setValue_A,
        clearErrors: clearErrors_A,
        formState: { errors: errors_A },
    } = useForm();

    useEffect(() => {
        if (!showModalEditarAula) {
            setEditAulaUrlExterna(false);
        }
    }, [showModalEditarAula]);

    const handleEditAulaTipoConteudoChange = (nextUrlExterna) => {
        setEditAulaUrlExterna(nextUrlExterna);
        if (clearErrors_A) {
            clearErrors_A(['file_0', 'file_1', 'file_2', 'html_externo']);
        }
        if (nextUrlExterna) {
            setFile0Selected(false);
            setFile1Selected(false);
            setFile2Selected(false);
            setValue_A('file_0', undefined);
            setValue_A('file_1', undefined);
            setValue_A('file_2', undefined);
        } else {
            setValue_A('html_externo', '');
        }
    };

    const handleDeleteQuestion = (id) => {
        const questao = dataQuestoes.find(q => q.id === id);
        setQuestaoParaDeletar({ id, questao: questao?.questao || '' });
        setShowModalAvaliacao(false);
        setShowModalDeletarQuestao(true);
    }

    const confirmDeleteQuestion = () => {
        if (!questaoParaDeletar) return;

        const id = questaoParaDeletar.id;
        setSelectedQuestao(null);
        setIsCreating(false);
        setAlternatives([]); // Limpa a lista de alternativas
        setValue("questao", ''); // Limpe o campo de questão
        setValue("resposta", ''); // Limpe a resposta correta
        setCorrectAnswer(''); // Limpa questao correta
        setSelectedValue(null); // Limpe o valor selecionado
        for (let index = 0; index < 20; index++) {
            setValue(`alternativa_${index}`, '');
        }

        async function fetchData() {
            try {
                const response = await Api.delete(`api/deletar-questao/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setSelectedValue(null)
                setReloadQuestoes(prevState => !prevState)
                setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' })
                setShowToast(true)
                setShowModalDeletarQuestao(false);
                setQuestaoParaDeletar(null);
            } catch (error) {
                console.error(error.response.data.message)
                setShowModalDeletarQuestao(false);
                setQuestaoParaDeletar(null);
            }
        }
        fetchData();
    }

    //Listar avaliacao e respostas
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/info-progresso-avaliacao/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setProgressoAvaliacao(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }

        nivel !== 'Administrador' && fetchData();
    }, [token, id, nivel]);

    const handleThumbnailChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = function (e) {
                setPreviewUrl(e.target.result);
            }
            reader.readAsDataURL(file);
        }
    }

    /////// Fim Avaliação P1


    // Buscar info do modulo
    useEffect(() => {
        async function fetchData() {
            try {
                setLoadingModulo(true);
                const response = await Api.get(`api/info-modulo/${id}`, { headers: { Authorization: `Bearer ${token}` } });
                setDataInfoModulo(response.data);
            } catch (error) {
                console.error(error.response.data.message)
                navigate("/");
            } finally {
                setLoadingModulo(false);
            }
        }
        fetchData();
    }, [token, id, navigate]);

    // Listar aulas
    const recarregarAulas = useCallback(async () => {
        try {
            setLoadingAulas(true);
            const response = await Api.get(`api/listar-aulas/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            setDataAulas(response.data);
        } catch (error) {
            console.error(error.response?.data?.message || error);
        } finally {
            setLoadingAulas(false);
        }
    }, [token, id]);

    useEffect(() => {
        recarregarAulas();
    }, [recarregarAulas, toast]);

    // Buscar cursos para o AulasManager
    const [dataCursos, setDataCursos] = useState([]);
    useEffect(() => {
        if (dataInfoModulo[0] && dataInfoModulo[0].idCurso) {
            async function fetchCursos() {
                try {
                    const response = await Api.get(`api/listar-todos-cursos`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    setDataCursos(response.data);
                } catch (error) {
                    console.error("Erro ao carregar cursos:", error);
                }
            }
            fetchCursos();
        }
    }, [token, dataInfoModulo]);

    // Inicializar AulasManager com idModulo do params
    // IMPORTANTE: AulasManager contém hooks, então deve ser SEMPRE chamado (não condicionalmente)
    const aulasManager = AulasManager({
        token,
        idModulo: id,
        idCurso: (dataInfoModulo && dataInfoModulo.length > 0 && dataInfoModulo[0]) ? dataInfoModulo[0].idCurso : "",
        dataCursos: dataCursos || [],
        moduloAtual: dataInfoModulo[0]
            ? { id: dataInfoModulo[0].id, nome: dataInfoModulo[0].nome, idCurso: dataInfoModulo[0].idCurso }
            : null,
        onAulaCreated: () => {
            recarregarAulas();
        }
    });

    // Buscar provas e atividades extras
    const [dataProvasExtras, setDataProvasExtras] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`/api/provas-extras-aluno/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataProvasExtras(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token, id])

    const columns = useMemo(
        () => [
            {
                Header: () => null, // Sem título para esta coluna
                id: 'nome_avaliacao',
                accessor: row => row.nomeAvaliacao,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex flex-column">
                        <span className="text-bold text-wrap">{value}</span>
                        <span className="text-muted fs-7">por {original.nomeGestor ? original.nomeGestor : "Automático"}</span>
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'status',
                accessor: row => row.status,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <>
                        {value === 1 ?
                            <div className="badge bg-success text-white">Concluido</div>
                            :
                            <div className="badge bg-dark text-white">Pendente</div>
                        }
                    </>
                )
            },
            {
                Header: () => null, // Sem título para esta coluna
                id: 'id',
                accessor: row => row.id,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex justify-content-end align-items-end">
                        {original.status === 0 ? (
                            <button onClick={() => { navigate(`/questionario/extra/${original.idAvaliacao}`) }} className="btn link text-primary rounded px-2">
                                Fazer avaliação
                            </button>
                        ) : (
                            podeVerPdfProva() ? (
                                <PDFDownloadLink document={<GerarPDF data={original.idAvaliacao} tipo="avaliacao_extra" titulo={original.nomeAvaliacao} />} fileName={`avaliacao_${original.nomeAvaliacao}.pdf`}>
                                    <div className="btn link text-primary rounded px-2">
                                        Consultar
                                    </div>
                                </PDFDownloadLink>
                            ) : (
                                <Tippy content="Acesso restrito: Seu certificado está próximo de expirar. É necessário refazer o curso para ter acesso novamente.">
                                    <button className="btn btn-sm btn-outline-secondary" disabled>
                                        <i className="bi bi-lock-fill me-1"></i>Restrito
                                    </button>
                                </Tippy>
                            )
                        )}
                    </div>
                )
            }
        ], [navigate, podeVerPdfProva]
    )

    const handleDeletarAula = async (id) => {
        try {
            const response = await Api.delete(`api/deletar-aula/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' })
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message, type: 'toast-error' })
            console.error(error.response.data.message)
        }
        setShowModalDeletar(false)
        setShowToast(true)
    }

    const onSubmitEditarAula = async (data) => {
        setIsLoadingEditarAula(true);
        const formData = new FormData();
        const htmlExt = typeof data.html_externo === 'string' ? data.html_externo.trim() : '';
        const isUrlExterna = htmlExt.length > 0;

        Object.keys(data).forEach(key => {
            if (isUrlExterna && key.startsWith('file_')) {
                return;
            }
            const value = data[key];
            if (key === 'html_externo' && !isUrlExterna) {
                return;
            }
            if (value === undefined || value === null) {
                return;
            }
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                if (value.length === 0) {
                    return;
                }
                Array.from(value).forEach(file => {
                    formData.append(key, file)
                });
            } else {
                formData.append(key, key === 'html_externo' ? htmlExt : value)
            }
        });

        try {
            const response = await Api.post("/api/editar-aula", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    setUploadAulaProgress(percentCompleted + "%")
                    if (percentCompleted === 100) {
                        setTimeout(() => {
                            setUploadAulaProgress('Aguarde... finalizando...')
                        }, 1000)
                    }
                }
            });

            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' })
            setFile0Selected(false)
            setFile1Selected(false)
            setFile2Selected(false)
            setUploadAulaProgress(0)

        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message, type: 'toast-error' })
            console.error("Erro ao criar nova aula:", error.response.data.message)
        } finally {
            setIsLoadingEditarAula(false);
        }
        setShowToast(true)
    };

    const handleAtribuirNotas = async () => {
        try {
            const response = await Api.get(`/api/listar-usuarios-curso-por-modulo/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setDataUsuarios(response.data);
            setFilteredUsuarios(response.data);
            setShowModalAtribuirNotas(true);
            setSearchTerm('');
        } catch (error) {
            console.error(error.response.data.message)
        }
    };

    const handleNotaChange = (id, value) => {
        setNotas(prevNotas => ({
            ...prevNotas,
            [id]: value
        }));
    };

    const handleSearch = (event) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);
        if (term) {
            setFilteredUsuarios(dataUsuarios.filter(usuario =>
                usuario.nome_completo.toLowerCase().includes(term)
            ));
        } else {
            setFilteredUsuarios(dataUsuarios);
        }
    };

    const handleSubmitNotas = () => {
        // console.log('Notas atribuídas:', notas);
        setShowModalAtribuirNotas(false);
        setShowModalAlunosComNotas(true);
    };

    const alunosComNotas = dataUsuarios.filter(usuario => notas[usuario.id]);

    const handleUpload = (idAluno) => {
        document.getElementById(`file-input-${idAluno}`).click();
    };

    const handleFileChange = (event, idAluno) => {
        const file = event.target.files[0];
        if (file) {
            setArquivos(prevArquivos => ({
                ...prevArquivos,
                [idAluno]: file
            }));
        }
    };

    useEffect(() => {
        const todosArquivosEnviados = alunosComNotas.every(usuario => arquivos[usuario.id]);
        setTodosArquivosEnviados(todosArquivosEnviados);
    }, [arquivos, alunosComNotas]);


    const handleGenerateQrCode = (idAluno) => {
        const url = `https://api.com/${id}/${idAluno}`;
        setQrCodeData(url);
        setShowModalQrCode(true);
        setShowModalAlunosComNotas(false);
    };

    const handleConcluir = async () => {
        setLoading(true)
        const dadosParaEnvio = alunosComNotas.map(usuario => ({
            idUsuario: usuario.id,
            acerto: notas[usuario.id],
            nota: notas[usuario.id]
        }));

        const formData = new FormData();
        formData.append('idModulo', id);
        formData.append('avaliacoes', JSON.stringify(dadosParaEnvio));

        alunosComNotas.forEach(usuario => {
            if (arquivos[usuario.id]) {
                formData.append(`file_${usuario.id}`, arquivos[usuario.id]);
            }
        });

        try {
            await Api.post('/api/salvar-avaliacoes', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            setShowModalFinalGrupo(true);
            setShowModalAlunosComNotas(false);
            setLoading(false);
        } catch (error) {
            console.error('Erro ao enviar dados:', error.response.data);
        }

        // function logFormData(fd) {
        //     for (let pair of fd.entries()) {
        //         console.log(pair[0] + ': ' + pair[1]);
        //     }
        // }
        // logFormData(formData);

    };

    useEffect(() => {
        if (statusAvaliacao === 'Fazer avaliação') {
            setTimeout(() => {
                setModalTemAvaliacao(true);
            }, 2000);
        }
    }, [statusAvaliacao]);

    return (
        <>
            <Toast
                show={showToast}
                onClose={() => setShowToast(false)}
                delay={4000}
                autohide
                className={`position-fixed top-0 end-0 m-3 toast-icon ${toast.type || 'toast-error'}`}
                style={{ zIndex: 1060 }}
            >
                <Toast.Header>
                    <strong className="me-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            <div className="fade-in w-100 mb-5">
                {/* Desktop: Voltar | links de ações (centro) | módulo */}
                <div className="d-none d-md-flex align-items-center gap-2 gap-md-3 mb-4 flex-wrap">
                    <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="btn btn-outline-primary rounded-pill px-4 py-1 d-flex align-items-center gap-2 shadow-sm flex-shrink-0"
                        style={{
                            transition: 'all 0.3s ease',
                            borderWidth: '2px',
                            fontWeight: '500'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateX(-5px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(13, 110, 253, 0.3)';
                            e.currentTarget.style.backgroundColor = '#0d6efd';
                            e.currentTarget.style.color = 'white';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateX(0)';
                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = '#0d6efd';
                        }}
                    >
                        <i className="bi bi-arrow-left fs-5"></i>
                        <span>Voltar</span>
                    </button>

                    {!loadingModulo && dataInfoModulo[0] && (
                        <nav
                            className="flex-grow-1 d-flex flex-wrap justify-content-end align-items-center gap-2 gap-lg-3 px-1 min-w-0"
                            aria-label="Ações do módulo"
                        >
                            {nivel !== 'Administrador' && (() => {
                                if (statusAvaliacao === 'Fazer avaliação') {
                                    return (
                                        <Link
                                            to={`/questionario/${id}`}
                                            className="btn btn-link btn-sm text-primary py-1 px-2 text-decoration-none"
                                        >
                                            <i className="bi bi-clipboard-check me-1"></i>
                                            Fazer avaliação
                                        </Link>
                                    );
                                }
                                if (
                                    statusAvaliacao === 'Avaliação concluída' &&
                                    avaliacaoReacaoStatus &&
                                    !avaliacaoReacaoStatus.avaliacao_reacao_concluida &&
                                    avaliacaoReacaoStatus.precisa_avaliacao_reacao &&
                                    !avaliacaoReacaoStatus.certificado_liberado
                                ) {
                                    return (
                                        <Link
                                            to={`/questionario/reacao/${id}`}
                                            className="btn btn-link btn-sm text-success py-1 px-2 text-decoration-none"
                                        >
                                            <i className="bi bi-star me-1"></i>
                                            Avaliação de Reação
                                        </Link>
                                    );
                                }
                                if (
                                    statusAvaliacao === 'Avaliação concluída' &&
                                    avaliacaoReacaoHibridoStatus &&
                                    avaliacaoReacaoHibridoStatus.pode_responder_avaliacao_reacao_hibrido &&
                                    !avaliacaoReacaoHibridoStatus.avaliacao_reacao_hibrido_concluida &&
                                    !avaliacaoReacaoHibridoStatus.certificado_liberado
                                ) {
                                    return (
                                        <Link
                                            to={`/questionario/reacao-hibrido/${id}`}
                                            className="btn btn-link btn-sm text-success py-1 px-2 text-decoration-none"
                                        >
                                            <i className="bi bi-star me-1"></i>
                                            Avaliação de Reação
                                        </Link>
                                    );
                                }
                                if (statusAvaliacao === 'Avaliação concluída') {
                                    return null;
                                }
                                return (
                                    <span className="btn btn-sm text-muted py-1 px-2 disabled border-0 bg-transparent">
                                        <i className="bi bi-x-circle me-1"></i>
                                        Avaliação indisponível
                                    </span>
                                );
                            })()}

                            {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'RH') && (
                                <button
                                    type="button"
                                    className="btn btn-link btn-sm text-primary py-1 px-2 text-decoration-none"
                                    onClick={handleAtribuirNotas}
                                >
                                    <i className="bi bi-people me-1"></i>
                                    Atribuir notas em grupo
                                </button>
                            )}

                            {nivel === 'Administrador' && (
                                <>
                                    <button
                                        type="button"
                                        className="btn btn-link btn-sm text-success py-1 px-2 text-decoration-none"
                                        onClick={() => aulasManager && aulasManager.openAddAulaModal()}
                                    >
                                        <i className="bi bi-plus-circle me-1"></i>
                                        Criar Aula
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-link btn-sm text-primary py-1 px-2 text-decoration-none"
                                        onClick={() => setShowModalAvaliacao(true)}
                                    >
                                        <i className="bi bi-gear me-1"></i>
                                        Configurar Avaliação
                                    </button>
                                </>
                            )}

                            {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'RH') && dataInfoModulo && dataInfoModulo[0] && (
                                <PDFDownloadLink
                                    document={<GerarPDF data={dataInfoModulo[0].id} tipo="avaliacao_normal_visualizacao" titulo={dataInfoModulo[0].nome} />}
                                    fileName={`avaliacao_${dataInfoModulo[0].nome}.pdf`}
                                    className="btn btn-link btn-sm text-primary py-1 px-2 text-decoration-none"
                                >
                                    <i className="bi bi-printer me-1"></i>
                                    Imprimir Avaliação
                                </PDFDownloadLink>
                            )}

                            {nivel !== 'Administrador' && (
                                <>
                                    <button
                                        type="button"
                                        className="btn btn-link btn-sm text-primary py-1 px-2 text-decoration-none"
                                        onClick={() => setShowModalAtividadeExtra(true)}
                                    >
                                        <i className="bi bi-file-earmark-text me-1"></i>
                                        Atividades / Provas extras
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-link btn-sm text-primary py-1 px-2 text-decoration-none"
                                        onClick={() => setShowModalMinhasNotas(true)}
                                    >
                                        <i className="bi bi-journal-text me-1"></i>
                                        Minhas notas
                                    </button>
                                </>
                            )}
                        </nav>
                    )}

                </div>

                {loadingModulo ? (
                    <ModuleBannerSkeleton />
                ) : dataInfoModulo[0] && (
                    <>
                        {/* Conteúdo principal */}
                        <div className="row g-0">
                            <div className="col-12">
                                {/* Banner responsivo com versões para desktop e mobile */}
                                <div 
                                    className="card card-flag rounded-4 w-100 overflow-hidden mb-4 border-none position-relative d-none d-md-block shadow-sm" 
                                    style={{ 
                                        height: '250px',
                                        maxHeight: '250px',
                                        minHeight: '250px'
                                    }}
                                >
                                    {/* Imagem e overlay do banner - Desktop */}
                                    <div className="position-absolute w-100 h-100 top-0 start-0" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}></div>
                                    <img 
                                        src={`${process.env.REACT_APP_IMG_URL}/${dataInfoModulo[0].thumbnail}`} 
                                        className="card-img w-100 position-absolute top-0 start-0" 
                                        alt={dataInfoModulo[0].nome}
                                        style={{ 
                                            height: '250px',
                                            objectFit: 'cover',
                                            width: '100%',
                                            zIndex: 0
                                        }}
                                    />
                                    <div className="card-img-overlay d-flex flex-column justify-content-between p-3 position-relative" style={{ zIndex: 2, height: '100%' }}>
                                        <div className="text-white text-center my-auto px-2">
                                            <h5 className="mb-1 fw-semibold" style={{ fontSize: 'clamp(1rem, 2vw, 1.5rem)' }}>{dataInfoModulo[0].nome}</h5>
                                            {dataInfoModulo[0].descricao && (
                                                <p className="mb-0 d-none d-lg-block" style={{ fontSize: 'clamp(0.75rem, 1.5vw, 1rem)' }}>{dataInfoModulo[0].descricao}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Banner Mobile - Estilo Moderno */}
                                <div className="d-md-none mb-3">
                                    <div className="position-relative rounded-4 overflow-hidden mb-3 shadow-sm">
                                        {/* Botão Voltar no Banner Mobile */}
                                        <button 
                                            onClick={() => navigate(-1)} 
                                            className="btn btn-light rounded-circle position-absolute top-0 start-0 m-3 d-flex align-items-center justify-content-center shadow"
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                zIndex: 10,
                                                transition: 'all 0.2s ease'
                                            }}
                                            onTouchStart={(e) => {
                                                e.currentTarget.style.transform = 'scale(0.95)';
                                                e.currentTarget.style.backgroundColor = '#e9ecef';
                                            }}
                                            onTouchEnd={(e) => {
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.backgroundColor = 'white';
                                            }}
                                        >
                                            <i className="bi bi-arrow-left fs-5 text-primary"></i>
                                        </button>
                                        
                                        <img
                                            src={`${process.env.REACT_APP_IMG_URL}/${dataInfoModulo[0].thumbnail}`}
                                            className="w-100"
                                            style={{ height: '220px', objectFit: 'cover' }}
                                            alt={dataInfoModulo[0].nome}
                                        />
                                        <div className="position-absolute w-100 h-100 top-0 start-0"
                                            style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.85) 100%)' }}>
                                        </div>
                                        <div className="position-absolute bottom-0 start-0 w-100 p-3 text-white">
                                            <h5 className="fw-bold mb-1 text-white" style={{ fontSize: '1.25rem', lineHeight: '1.3' }}>
                                                {dataInfoModulo[0].nome}
                                            </h5>
                                            {dataInfoModulo[0].descricao && (
                                                <p className="mb-0 text-white-50 small d-none d-sm-block" style={{ fontSize: '0.875rem' }}>
                                                    {dataInfoModulo[0].descricao}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Botões de ação mobile */}
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div className="d-flex align-items-center">
                                            <div className="badge bg-primary text-white rounded-pill px-3 py-2">
                                                <i className="bi bi-collection me-1"></i>
                                                Aulas ({dataAulas.length})
                                            </div>
                                        </div>

                                        <div className="d-flex gap-2">
                                            <button 
                                                onClick={() => setShowDrawerMobile(true)}
                                                className="btn btn-primary rounded-pill px-3"
                                            >
                                                <i className="bi bi-list me-2"></i>Ações
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Conteúdo do body */}
                                <div className="body p-1 p-md-3">
                    <section className="w-100">

                        {!loadingModulo && dataInfoModulo[0]?.descricao && (
                            <div className="row mb-3">
                                <h5 className="text-primary fw-bold">Descrição do Módulo</h5>
                                <p>{dataInfoModulo[0].descricao}</p>
                            </div>
                        )}

                        <div className="row mb-3 pb-5 pb-md-0">
                            {loadingAulas ? (
                                <AulaSkeletons count={6} />
                            ) : (
                                dataAulas.map((value, index) => {
                                    return (
                                        <div key={value.id} className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-4 mt-2">
                                            <div className={`card-body mt-3 shadow-sm rounded-4 p-3 position-relative ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'RH')
                                                ? 'bg-success'
                                                : 'bg-white'
                                                }`}>
                                                {/* Dropdown de Ações - Posição Superior Direita */}
                                                {nivel === 'Administrador' && (
                                                    <div className="position-absolute top-0 end-0 m-2" style={{ zIndex: 10 }}>
                                                        <DropdownMenu
                                                            toggle={
                                                                <button 
                                                                    className="btn btn-none p-0 border-0 bg-transparent"
                                                                    style={{
                                                                        width: '32px',
                                                                        height: '32px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        borderRadius: '6px',
                                                                        transition: 'background-color 0.15s ease',
                                                                        color: value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'RH') ? 'rgba(255,255,255,0.8)' : '#6c757d'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.backgroundColor = value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'RH') ? 'rgba(255,255,255,0.2)' : '#f8f9fa';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor = 'transparent';
                                                                    }}
                                                                >
                                                                    <i className="bi bi-three-dots-vertical" style={{ fontSize: '1.25rem' }}></i>
                                                                </button>
                                                            }
                                                            items={[
                                                                {
                                                                    icon: 'pencil',
                                                                    label: 'Editar Aula',
                                                                    onClick: () => {
                                                                        setShowModalEditarAula(true)
                                                                        setValue_A('id', value.id)
                                                                        setValue_A('titulo', value.titulo)
                                                                        setValue_A('descricao', value.descricao)
                                                                        setValue_A('resumo', value.resumo)
                                                                        const ext = value.html_externo && String(value.html_externo).trim();
                                                                        setEditAulaUrlExterna(Boolean(ext))
                                                                        setValue_A('html_externo', ext || '')
                                                                        setFile0Selected(false)
                                                                        setFile1Selected(false)
                                                                        setFile2Selected(false)
                                                                        setValue_A('file_0', undefined)
                                                                        setValue_A('file_1', undefined)
                                                                        setValue_A('file_2', undefined)
                                                                        if (clearErrors_A) clearErrors_A(['file_0', 'file_1', 'file_2', 'html_externo'])
                                                                        setUploadAulaProgress(0)
                                                                    }
                                                                },
                                                                {
                                                                    divider: true
                                                                },
                                                                {
                                                                    icon: 'trash',
                                                                    label: 'Excluir Aula',
                                                                    onClick: () => {
                                                                        setShowModalDeletar(true)
                                                                        setDeletarAula({ id: value.id, titulo: value.titulo })
                                                                    },
                                                                    className: 'text-danger',
                                                                    style: { color: '#dc3545' }
                                                                }
                                                            ]}
                                                            align="end"
                                                        />
                                                    </div>
                                                )}

                                                {/* Cabeçalho do Card */}
                                                <div className="d-flex flex-column mb-3">
                                                    <div className={`card-title ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'RH')
                                                        ? 'text-white'
                                                        : 'text-primary'
                                                        }`}>
                                                        <span className={`small border border-2 rounded-3 px-2 fw-bold fs-6 ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'RH')
                                                            ? 'text-white border-white'
                                                            : 'text-primary border-primary'
                                                            }`}>
                                                            Aula {index + 1}
                                                        </span>
                                                        <span className="ms-2 d-inline-block text-truncate" style={{ maxWidth: '100%', position: 'relative', top: 5 }}>
                                                            {value.titulo}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Área de Ações */}
                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                    {/* Badge Assistida */}
                                                    {value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'RH') && (
                                                        <span className="bg-white text-success rounded-3 p-1 fs-8">
                                                            <i className="bi bi-check-circle-fill"></i> Assistida
                                                        </span>
                                                    )}

                                                    {/* Botões de Acesso */}
                                                    <div className="d-flex gap-2">
                                                        <Link
                                                            to={`/aula/${value.id}`}
                                                            className={`btn btn-sm ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'RH')
                                                                ? 'text-white'
                                                                : 'text-dark link'
                                                                }`}
                                                        >
                                                            Acessar
                                                        </Link>

                                                        {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'RH') && (
                                                            <Link
                                                                to={`/aula-grupo/${value.id}`}
                                                                className={`btn btn-sm ${value.aula_assistida === 1 && (nivel !== 'Administrador' || nivel !== 'RH')
                                                                    ? 'text-white'
                                                                    : 'text-dark link'
                                                                    }`}
                                                            >
                                                                Acessar em Grupo
                                                            </Link>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            )}
                        </div>

                                </section>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <Modal size="lg" show={modalTemAvaliacao} onHide={() => setModalTemAvaliacao(false)} centered>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">📋 Avaliação Disponível</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="d-flex flex-column w-100 text-center">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <p className="fs-5">🎉 A avaliação do módulo <strong>{dataInfoModulo[0] && dataInfoModulo[0].nome}</strong> está disponível!</p>
                                    <p className="fs-6">Clique no botão abaixo para iniciar sua avaliação.</p>
                                    <Link to={`/questionario/${id}`} className="btn btn-secondary text-white mt-3">Iniciar Avaliação</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={modalTemAvaliacaoReacao} onHide={() => setModalTemAvaliacaoReacao(false)} centered>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">🌟 Avaliação de Reação</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="d-flex flex-column w-100 text-center">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <p className="fs-5">✅ Parabéns por concluir a avaliação do módulo <strong>{dataInfoModulo[0] && dataInfoModulo[0].nome}</strong>!</p>
                                    <p className="fs-6">Agora, precisamos que você responda à <strong>Avaliação de Reação</strong> para liberar seu certificado.</p>
                                    <p className="fs-7 text-muted">Esta avaliação é sobre sua experiência com o treinamento.</p>
                                    <Link to={`/questionario/reacao/${id}`} className="btn btn-primary text-white mt-3">Responder Avaliação de Reação</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={modalTemAvaliacaoReacaoHibrido} onHide={() => setModalTemAvaliacaoReacaoHibrido(false)} centered>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">🌟 Avaliação de Reação - Curso Misto</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="d-flex flex-column w-100 text-center">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <p className="fs-5">✅ Você já completou as aulas, a avaliação e a prática do curso <strong>{dataInfoModulo[0] && dataInfoModulo[0].nome}</strong>!</p>
                                    <p className="fs-6">Agora, para finalizar e receber seu certificado, precisamos que você responda à <strong>Avaliação de Reação para Cursos Mistos</strong>.</p>
                                    <p className="fs-7 text-muted">Esta avaliação é sobre sua experiência com o treinamento teórico e prático.</p>
                                    <Link to={`/questionario/reacao-hibrido/${id}`} className="btn btn-primary text-white mt-3">Responder Avaliação de Reação</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={showModalAvaliacao} onHide={() => {
                setShowModalAvaliacao(false); setSelectedQuestao(null);
                setIsCreating(false);
                setSelectedValue(null);
                reset()
                for (let index = 0; index < 10; index++) {
                    setValue(`alternativa_${index}`, '');
                }
            }} backdrop="static">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Header closeButton>
                        <span className="fw-semibold fs-5 text-primary">Avaliação <span className="text-dark fs-6">({dataInfoModulo[0] && dataInfoModulo[0].nome})</span></span>
                    </Modal.Header>
                    <Modal.Body className="bg-gray-100 p-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex mb-1">
                                        <div className="d-flex flex-column w-100">

                                            <div className="row mb-3">

                                                <div className="col-12">
                                                    {!isCreating && (
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Selecione a questão</label>

                                                            <Controller
                                                                name="questaoSelecionada"
                                                                control={control}
                                                                defaultValue={[]}
                                                                render={({ field }) => (
                                                                    <Select
                                                                        {...field}
                                                                        options={dataQuestoes.map((value, index) => {
                                                                            setValue("tempo", dataQuestoes[0].tempo);
                                                                            return {
                                                                                value: value.id,
                                                                                label: `${index + 1} - ${truncateString(value.questao)}`,
                                                                            };
                                                                        })}
                                                                        value={selectedValue} // Use o estado aqui
                                                                        styles={customStyles}
                                                                        onChange={(value) => {
                                                                            if (value && selectedQuestao && value.value === selectedQuestao.id) return;
                                                                            field.onChange(value);
                                                                            setSelectedValue(value); // Atualize o estado aqui
                                                                            const selected = dataQuestoes.find((q) => q.id === value.value);
                                                                            setSelectedQuestao(selected);
                                                                            setValue("data_disponibilidade", dataQuestoes[0].data_disponibilidade);
                                                                            setValue("data_disponibilidade_fim", dataQuestoes[0].data_disponibilidade_fim);
                                                                        }}
                                                                        placeholder="Selecione uma questão"
                                                                        isSearchable
                                                                        noOptionsMessage={() => "Nenhuma questão encontrada."}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    )}

                                                    <p className="btn-link fs-7 ms-2 cursor-pointer" onClick={handleCreateNewQuestion}>Adicionar nova questão</p>

                                                </div>

                                            </div>
                                            {(selectedQuestao || isCreating) && (
                                                <>
                                                    <div className="row mb-3">
                                                        <div className="col-12 col-md-12">
                                                            <div className="mb-3">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <label className="form-label text-primary fw-medium mb-0">Questão</label>
                                                                    {!isCreating && (
                                                                        <Tippy content="Deletar essa questão">
                                                                            <i className="bi bi-trash cursor-pointer tt-deletar" onClick={() => handleDeleteQuestion(selectedQuestao.id)}></i>
                                                                        </Tippy>
                                                                    )}
                                                                </div>

                                                                <TextareaAutosize
                                                                    rows={3}
                                                                    {...register("questao", { required: true, defaultValue: selectedQuestao ? selectedQuestao.questao : '' })}
                                                                    className="form-control border-new-light"
                                                                />
                                                                {errors.questao && <span className='text-danger fs-7'>Questão é obrigatório.</span>}
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-12">
                                                            <div className="mb-3">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <label className="form-label text-primary fw-medium mb-0">Imagem</label>
                                                                </div>

                                                                <label htmlFor="imagem" className={`form-control label-input ${cursoEditarFile ? 'border-success bg-success' : 'border-primary bg-primary'} text-white fw-medium text-center`}>
                                                                    <i className="bi bi-card-image me-2"></i> Enviar Imagem
                                                                </label>

                                                                <Controller
                                                                    control={control}
                                                                    name="imagem"
                                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                        <input
                                                                            id='imagem'
                                                                            type="file"
                                                                            onBlur={onBlur}
                                                                            ref={ref}
                                                                            onChange={(e) => {
                                                                                const files = e.target.files;
                                                                                handleThumbnailChange(e);
                                                                                onChange(files);
                                                                                if (files && files.length > 0) {
                                                                                    setCursoEditarFile(true);
                                                                                } else {
                                                                                    setCursoEditarFile(false);
                                                                                }
                                                                            }}
                                                                        />
                                                                    )}
                                                                />

                                                                {previewUrl ?
                                                                    <div className="d-flex justify-content-center mt-2">
                                                                        <img src={previewUrl} className='card-img-question-edit rounded-3' alt="Thumbnail" />
                                                                    </div>
                                                                    :
                                                                    <div className="d-flex justify-content-center mt-2">
                                                                        {selectedQuestao && selectedQuestao.imagem &&
                                                                            <img src={`${process.env.REACT_APP_IMG_URL}/${selectedQuestao.imagem}`} className='card-img-question-edit rounded-3' alt="Thumbnail" />
                                                                        }
                                                                    </div>
                                                                }


                                                            </div>
                                                        </div>

                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium col-12">Alternativas</label>
                                                            {alternatives.map((_, index) => (
                                                                <div className="input-group mb-3" key={index}>
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text bg-primary text-white" id="basic-addon1">{index + 1}</span>
                                                                    </div>
                                                                    <input type="text" {...register(`alternativa_${index}`, { required: true })} className="form-control border-new-light" />
                                                                    <button type="button" className="btn btn-primary text-white" onClick={() => removeAlternative(index)}>-</button>
                                                                </div>
                                                            ))}
                                                            <button className="btn btn-primary text-white" type="button" onClick={addAlternative}>+</button>
                                                        </div>


                                                        <div className="col-12 col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Alternativa Correta</label>
                                                                <select
                                                                    {...register("resposta")}
                                                                    value={correctAnswer} // Use correctAnswer aqui
                                                                    onChange={(e) => setCorrectAnswer(Number(e.target.value))}
                                                                    aria-label="Default select example"
                                                                    className="form-select border-primary"
                                                                >
                                                                    <option value="">Selecione a alternativa correta</option>
                                                                    {alternatives.map((_, index) => (
                                                                        <option key={index} value={index + 1}>
                                                                            Alternativa {index + 1}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Tempo da avaliação</label>
                                                                <input
                                                                    type="number"
                                                                    {...register("tempo", { required: true })}
                                                                    className="form-control border-new-light"
                                                                    placeholder="Digite o tempo da avaliação em minutos"
                                                                />
                                                                <label className="form-label text-dark fw-normal fs-7">em minutos</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Data de Disponibilidade</label>
                                                                <input
                                                                    type="date"
                                                                    {...register("data_disponibilidade", { required: true })}
                                                                    className="form-control border-new-light"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Disponível até</label>
                                                                <input
                                                                    type="date"
                                                                    {...register("data_disponibilidade_fim", { required: true })}
                                                                    className="form-control border-new-light"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-between">
                        <div className="d-flex align-items-center">
                            {dataInfoModulo[0] && nivel === "Administrador" && (
                                <PDFDownloadLink
                                    document={<GerarPDF data={dataInfoModulo && dataInfoModulo[0] ? dataInfoModulo[0].id : null} tipo="avaliacao_completa_visualizacao" titulo={dataInfoModulo && dataInfoModulo[0] ? dataInfoModulo[0].nome : ''} />}
                                    fileName={`avaliacao_${dataInfoModulo && dataInfoModulo[0] ? dataInfoModulo[0].nome : ''}.pdf`}
                                >
                                    <p className="btn-link fs-7 mb-0 cursor-pointer">Visualizar avaliação</p>
                                </PDFDownloadLink>
                            )}
                        </div>
                        {(selectedQuestao || isCreating) && (
                            <div className="d-flex justify-content-end">
                                <button
                                    type="button"
                                    className="btn me-2"
                                    onClick={() => {
                                        setShowModalAvaliacao(false);
                                        setSelectedQuestao(null);
                                        setIsCreating(false);
                                        reset();
                                        setSelectedValue(null);
                                        for (let index = 0; index < 10; index++) {
                                            setValue(`alternativa_${index}`, '');
                                        }
                                    }}
                                >
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    Salvar
                                </button>
                            </div>
                        )}
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal size="lg" show={showModalEditarAula} onHide={() => setShowModalEditarAula(false)} backdrop="static">
                <form onSubmit={handleSubmit_A(onSubmitEditarAula)}>
                    <Modal.Header closeButton>
                        <span className="fw-semibold fs-5 text-primary">Editar Aula</span>
                    </Modal.Header>
                    <Modal.Body className="bg-gray-100 p-4">
                        <input type="hidden" {...register_A('id', { required: true })} />
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="body">
                                        <div className="d-flex mb-5">
                                            <div className="d-flex flex-column w-100">
                                                <div className="row">

                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className='col-12 h-100 red-bg d-flex align-items-center justify-content-center rounded-3'>
                                                                <i className={`bi icon-large text-white ${editAulaUrlExterna ? 'bi-link-45deg' : 'bi-cloud-upload'}`}></i>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8 mt-3">
                                                            <div className="row">
                                                                <div className="col-12 col-md-12">
                                                                    <div className="mb-3">
                                                                        <input type="text" {...register_A("titulo", { required: true })} placeholder="Título da aula" className="form-control border-new-light" />
                                                                        {errors_A.titulo && <span className='text-danger fs-7'>Aula é obrigatório.</span>}
                                                                    </div>
                                                                </div>

                                                                <div className="col-12 col-md-12">
                                                                    <div className="mb-3">
                                                                        <TextareaAutosize type="text" {...register_A("descricao", { required: true })} placeholder="Descrição da aula" className="form-control border-new-light" />
                                                                        {errors_A.descricao && <span className='text-danger fs-7'>Aula é obrigatório.</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mt-3'>
                                                        <div className="col-12 mb-3">
                                                            <div className="p-3 bg-white rounded-3 border">
                                                                <p className="fs-7 text-muted mb-2 mb-md-3">Conteúdo da aula</p>
                                                                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2 gap-sm-4">
                                                                    <span className={`small ${!editAulaUrlExterna ? 'fw-semibold text-dark' : 'text-muted'}`}>
                                                                        <i className="bi bi-hdd me-1"></i>
                                                                        Arquivo no computador
                                                                    </span>
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id="editar-aula-conteudo-externo-switch"
                                                                        checked={editAulaUrlExterna}
                                                                        onChange={(e) => handleEditAulaTipoConteudoChange(e.target.checked)}
                                                                        className="form-check form-switch mx-sm-2"
                                                                        aria-label="Alternar entre arquivo local e URL externa"
                                                                    />
                                                                    <span className={`small ${editAulaUrlExterna ? 'fw-semibold text-dark' : 'text-muted'}`}>
                                                                        <i className="bi bi-globe2 me-1"></i>
                                                                        URL externa
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {editAulaUrlExterna && (
                                                            <div className="col-12 mb-3">
                                                                <label htmlFor="html_externo_editar" className="form-label fs-7">
                                                                    Link do conteúdo <span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    id="html_externo_editar"
                                                                    type="text"
                                                                    autoComplete="url"
                                                                    inputMode="url"
                                                                    placeholder="https://… ou link do YouTube / Vimeo"
                                                                    className="form-control border-new-light"
                                                                    {...register_A('html_externo', {
                                                                        validate: (v) =>
                                                                            !editAulaUrlExterna ||
                                                                            (v != null && String(v).trim() !== '') ||
                                                                            'Informe a URL da aula',
                                                                    })}
                                                                />
                                                                <p className="text-muted fs-8 mt-1 mb-0">
                                                                    Usa o vídeo ou página web informada; não é necessário enviar arquivo.
                                                                </p>
                                                                {errors_A.html_externo && (
                                                                    <span className="text-danger fs-7">{errors_A.html_externo.message}</span>
                                                                )}
                                                            </div>
                                                        )}

                                                        {!editAulaUrlExterna && (
                                                        <>
                                                        <div className="col-6 col-md-4">
                                                            <div className="mb-3">
                                                                <div
                                                                    className="card border-none cursor-pointer"
                                                                    role="button"
                                                                    tabIndex={0}
                                                                    onClick={() => document.getElementById('file_0_edit_aula')?.click()}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                                            e.preventDefault();
                                                                            document.getElementById('file_0_edit_aula')?.click();
                                                                        }
                                                                    }}
                                                                    aria-label="Selecionar arquivo da aula"
                                                                >
                                                                    <p className='fs-7 fw-bold m-2'>Arquivo da aula</p>
                                                                    <h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
                                                                        <i className="bi bi-file-earmark-fill"></i>
                                                                    </h5>
                                                                    <div className="card-body d-flex justify-content-center bg-light">
                                                                        <p className="card-text fs-7 mb-0">
                                                                            <span className={`${file0Selected ? 'text-success' : 'text-primary'}`}>Fazer Upload <i className="bi bi-cloud-upload"></i></span>
                                                                            <Controller
                                                                                control={control_A}
                                                                                name="file_0"
                                                                                render={({ field: { onChange, onBlur, ref } }) => (
                                                                                    <input
                                                                                        style={{ display: 'none' }}
                                                                                        id='file_0_edit_aula'
                                                                                        type="file"
                                                                                        onBlur={onBlur}
                                                                                        ref={ref}
                                                                                        onChange={(e) => {
                                                                                            const files = e.target.files;
                                                                                            onChange(files);
                                                                                            if (files && files.length > 0) {
                                                                                                setFile0Selected(true);
                                                                                            } else {
                                                                                                setFile0Selected(false);
                                                                                            }
                                                                                        }}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    />
                                                                                )}
                                                                            />
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 col-md-4 border-start border-primary">
                                                            <div className="mb-3">
                                                                <div
                                                                    className="card border-none cursor-pointer"
                                                                    role="button"
                                                                    tabIndex={0}
                                                                    onClick={() => document.getElementById('file_1_edit_aula')?.click()}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                                            e.preventDefault();
                                                                            document.getElementById('file_1_edit_aula')?.click();
                                                                        }
                                                                    }}
                                                                    aria-label="Selecionar arquivo auxiliar 1"
                                                                >
                                                                    <p className='fs-7 m-2'>Arquivo Auxiliar 1</p>
                                                                    <h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
                                                                        <i className="bi bi-file-earmark-fill"></i>
                                                                    </h5>
                                                                    <div className="card-body d-flex justify-content-center bg-light">
                                                                        <p className="card-text fs-7 mb-0">
                                                                            <span className={`${file1Selected ? 'text-success' : 'text-primary'}`}>Fazer Upload  <i className="bi bi-cloud-upload"></i></span>
                                                                            <Controller
                                                                                control={control_A}
                                                                                name="file_1"
                                                                                render={({ field: { onChange, onBlur, ref } }) => (
                                                                                    <input
                                                                                        style={{ display: 'none' }}
                                                                                        id='file_1_edit_aula'
                                                                                        type="file"
                                                                                        onBlur={onBlur}
                                                                                        ref={ref}
                                                                                        onChange={(e) => {
                                                                                            const files = e.target.files;
                                                                                            onChange(files);
                                                                                            if (files && files.length > 0) {
                                                                                                setFile1Selected(true);
                                                                                            } else {
                                                                                                setFile1Selected(false);
                                                                                            }
                                                                                        }}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    />
                                                                                )}
                                                                            />
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4">
                                                            <div className="mb-3">
                                                                <div
                                                                    className="card border-none cursor-pointer"
                                                                    role="button"
                                                                    tabIndex={0}
                                                                    onClick={() => document.getElementById('file_2_edit_aula')?.click()}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                                            e.preventDefault();
                                                                            document.getElementById('file_2_edit_aula')?.click();
                                                                        }
                                                                    }}
                                                                    aria-label="Selecionar arquivo auxiliar 2"
                                                                >
                                                                    <p className='fs-7 m-2'>Arquivo Auxiliar 2</p>
                                                                    <h5 className="card-header card-upload d-flex align-items-center justify-content-center ">
                                                                        <i className="bi bi-file-earmark-fill"></i>
                                                                    </h5>
                                                                    <div className="card-body d-flex justify-content-center bg-light">
                                                                        <p className="card-text text-primary fs-7 mb-0">
                                                                            <span className={`${file2Selected ? 'text-success' : 'text-primary'}`}>Fazer Upload  <i className="bi bi-cloud-upload"></i></span>

                                                                            <Controller
                                                                                control={control_A}
                                                                                name="file_2"
                                                                                render={({ field: { onChange, onBlur, ref } }) => (
                                                                                    <input
                                                                                        style={{ display: 'none' }}
                                                                                        id='file_2_edit_aula'
                                                                                        type="file"
                                                                                        onBlur={onBlur}
                                                                                        ref={ref}
                                                                                        onChange={(e) => {
                                                                                            const files = e.target.files;
                                                                                            onChange(files);
                                                                                            if (files && files.length > 0) {
                                                                                                setFile2Selected(true);
                                                                                            } else {
                                                                                                setFile2Selected(false);
                                                                                            }
                                                                                        }}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    />
                                                                                )}
                                                                            />
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {errors_A.file_0 && <span className='text-danger fs-7'>Arquivo da aula é obrigatório.</span>}
                                                        </>
                                                        )}
                                                    </div>


                                                </div>
                                                {!editAulaUrlExterna && (
                                                <div className="progress col-12 mt-4">
                                                    <div className="progress-bar" role="progressbar" style={{ width: `${uploadAulaProgress}` }} aria-valuenow={uploadAulaProgress} aria-valuemin="0" aria-valuemax="100">{uploadAulaProgress}</div>
                                                </div>
                                                )}
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-end">
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn me-2" onClick={() => setShowModalEditarAula(false)} disabled={isLoadingEditarAula}>Cancelar</button>
                            <button type="submit" className="btn btn-primary" disabled={isLoadingEditarAula}>
                                {isLoadingEditarAula ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Salvando...
                                    </>
                                ) : (
                                    'Salvar'
                                )}
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal size='lg' show={showModalDeletar} onHide={() => setShowModalDeletar(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-5 text-primary">Deletar aula</span>
                </Modal.Header>
                <Modal.Body className="bg-gray-100 p-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p>Tem certeza que deseja deletar a aula <b>{deletarAula.titulo}</b>?</p>
                                                    <p>Essa ação ira deletar a aula e seu conteúdo? Não será possível recuperar.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn me-2" onClick={() => setShowModalDeletar(false)}>Cancelar</button>
                        <button type="button" className="btn btn-danger" onClick={() => handleDeletarAula(deletarAula.id)}>Confirmar</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalDeletarQuestao} onHide={() => {
                setShowModalDeletarQuestao(false);
                setQuestaoParaDeletar(null);
                setShowModalAvaliacao(true);
            }}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-5 text-primary">Deletar questão</span>
                </Modal.Header>
                <Modal.Body className="bg-gray-100 p-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p>Tem certeza que deseja deletar esta questão?</p>
                                                    {questaoParaDeletar && (
                                                        <p className="mb-0">Essa ação irá deletar a questão <b>{truncateString(questaoParaDeletar.questao, 100)}</b> e não será possível recuperar.</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn me-2" onClick={() => {
                            setShowModalDeletarQuestao(false);
                            setQuestaoParaDeletar(null);
                            setShowModalAvaliacao(true);
                        }}>Cancelar</button>
                        <button type="button" className="btn btn-danger" onClick={confirmDeleteQuestion}>Confirmar</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="xl" show={showModalMinhasNotas} onHide={() => setShowModalMinhasNotas(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Minhas Avaliações</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Módulo</th>
                                                                <th scope="col" className="text-center">Acertos</th>
                                                                <th scope="col" className="text-center">Nota</th>
                                                                <th scope="col" className="text-center">Data</th>
                                                                <th scope="col" className="text-center">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        {progressoAvaliacao &&
                                                            <tbody>
                                                                {progressoAvaliacao.progresso_avaliacao &&
                                                                    <tr>
                                                                        <td className="text-start fw-normal text-nowrap">
                                                                            <Tippy content={`${progressoAvaliacao.progresso_avaliacao.nomeModulo} - Avaliação`}>
                                                                                <span>{truncateString(progressoAvaliacao.progresso_avaliacao.nomeModulo, 30)} - <b>Avaliação</b></span>
                                                                            </Tippy>
                                                                        </td>
                                                                        <td className="text-center">{progressoAvaliacao.progresso_avaliacao.acerto}</td>
                                                                        <td className="text-center">{progressoAvaliacao.progresso_avaliacao.nota ? progressoAvaliacao.progresso_avaliacao.nota : '0'}</td>
                                                                        <td className="text-center small">{progressoAvaliacao.progresso_avaliacao.data_formatada}</td>
                                                                        <td className="text-center">
                                                                            {podeVerPdfProva() ? (
                                                                                <PDFDownloadLink
                                                                                    document={<GerarPDF data={progressoAvaliacao.progresso_avaliacao} titulo={progressoAvaliacao.progresso_avaliacao.nomeModulo} tipo="avaliacao" />}
                                                                                    fileName={`avaliacao_${progressoAvaliacao.progresso_avaliacao.nomeModulo}.pdf`}
                                                                                >
                                                                                    <button className="btn btn-sm btn-outline-primary text-nowrap">Ver Prova</button>
                                                                                </PDFDownloadLink>
                                                                            ) : (
                                                                                <Tippy content="Certificado expirado ou indisponível">
                                                                                    <button className="btn btn-sm btn-outline-secondary" disabled>
                                                                                        <i className="bi bi-lock-fill me-1"></i>Restrito
                                                                                    </button>
                                                                                </Tippy>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                }

                                                                {/* Histórico de provas anteriores (arquivadas) */}
                                                                {progressoAvaliacao.progresso_avaliacao_arquivada && progressoAvaliacao.progresso_avaliacao_arquivada.map((item, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td className="text-start fw-normal text-nowrap">
                                                                                <Tippy content={`${item.nomeModulo} - Avaliação`}>
                                                                                    <span>{truncateString(item.nomeModulo, 30)} - <b>Avaliação</b></span>
                                                                                </Tippy>
                                                                            </td>
                                                                            <td className="text-center">{item.acerto}</td>
                                                                            <td className="text-center">{item.nota ? item.nota : '0'}</td>
                                                                            <td className="text-center small">{item.data_formatada}</td>
                                                                            <td className="text-center">
                                                                                {nivel === 'Administrador' || nivel === 'RH' ? (
                                                                                    <PDFDownloadLink
                                                                                        document={<GerarPDF data={item} titulo={item.nomeModulo} tipo="avaliacao" />}
                                                                                        fileName={`avaliacao_anterior_${item.nomeModulo}.pdf`}
                                                                                    >
                                                                                        <button className="btn btn-sm btn-outline-secondary">Ver Prova</button>
                                                                                    </PDFDownloadLink>
                                                                                ) : (
                                                                                    <Tippy content="Apenas administradores, gestores e RH podem visualizar provas anteriores">
                                                                                        <button className="btn btn-sm btn-outline-secondary" disabled>
                                                                                            <i className="bi bi-lock-fill me-1"></i>Restrito
                                                                                        </button>
                                                                                    </Tippy>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}

                                                                {/* Avaliação de Reação */}
                                                                {progressoAvaliacao.progresso_avaliacao_reacao &&
                                                                    <tr>
                                                                        <td className="text-start fw-normal text-nowrap">
                                                                            <Tippy content={`${progressoAvaliacao.progresso_avaliacao_reacao.nomeModulo} - Avaliação de Reação`}>
                                                                                <span>{truncateString(progressoAvaliacao.progresso_avaliacao_reacao.nomeModulo, 30)} - <b>Avaliação de Reação</b></span>
                                                                            </Tippy>
                                                                        </td>
                                                                        <td className="text-center">-</td>
                                                                        <td className="text-center">-</td>
                                                                        <td className="text-center small">{progressoAvaliacao.progresso_avaliacao_reacao.data_formatada}</td>
                                                                        <td className="text-center">
                                                                            <button
                                                                                className="btn btn-sm btn-outline-success"
                                                                                onClick={() => {
                                                                                    setModalVerAvaliacaoReacao({
                                                                                        show: true,
                                                                                        data: progressoAvaliacao.progresso_avaliacao_reacao
                                                                                    });
                                                                                }}
                                                                            >
                                                                                Ver Avaliação
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                }

                                                                {/* Avaliação de Reação Híbrida */}
                                                                {progressoAvaliacao.progresso_avaliacao_reacao_hibrido &&
                                                                    <tr>
                                                                        <td className="text-start fw-normal text-nowrap">
                                                                            <Tippy content={`${progressoAvaliacao.progresso_avaliacao_reacao_hibrido.nomeModulo} - Avaliação de Reação Misto/Híbrido`}>
                                                                                <span>{truncateString(progressoAvaliacao.progresso_avaliacao_reacao_hibrido.nomeModulo, 30)} - <b>Avaliação de Reação</b></span>
                                                                            </Tippy>
                                                                        </td>
                                                                        <td className="text-center">-</td>
                                                                        <td className="text-center">-</td>
                                                                        <td className="text-center small">{progressoAvaliacao.progresso_avaliacao_reacao_hibrido.data_formatada}</td>
                                                                        <td className="text-center">
                                                                            <button
                                                                                className="btn btn-sm btn-outline-success"
                                                                                onClick={() => {
                                                                                    setModalVerAvaliacaoReacao({
                                                                                        show: true,
                                                                                        data: progressoAvaliacao.progresso_avaliacao_reacao_hibrido
                                                                                    });
                                                                                }}
                                                                            >
                                                                                Ver Avaliação
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                }

                                                                {progressoAvaliacao.progresso_avaliacao_extra && progressoAvaliacao.progresso_avaliacao_extra.map((item, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td className="text-start fw-normal text-nowrap">
                                                                                <Tippy content={item.nomeAvaliacaoExtra}>
                                                                                    <span>{truncateString(item.nomeAvaliacaoExtra, 30)}</span>
                                                                                </Tippy>
                                                                            </td>
                                                                            <td className="text-center">{item.acerto}</td>
                                                                            <td className="text-center">{item.nota ? item.nota : '-'}</td>
                                                                            <td className="text-center">{item.data_formatada}</td>
                                                                            <td className="text-center">
                                                                                {podeVerPdfProva() ? (
                                                                                    <PDFDownloadLink
                                                                                        document={<GerarPDF data={item.idAvaliacao} tipo="avaliacao_extra" titulo={item.nomeAvaliacaoExtra} />}
                                                                                        fileName={`avaliacao_extra_${item.nomeAvaliacaoExtra}.pdf`}
                                                                                    >
                                                                                        <button className="btn btn-sm btn-outline-info">Ver Prova</button>
                                                                                    </PDFDownloadLink>
                                                                                ) : (
                                                                                    <Tippy content="Acesso restrito: Seu certificado está próximo de expirar. É necessário refazer o curso para ter acesso novamente.">
                                                                                        <button className="btn btn-sm btn-outline-secondary" disabled>
                                                                                            <i className="bi bi-lock-fill me-1"></i>Restrito
                                                                                        </button>
                                                                                    </Tippy>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size='lg' show={showModalAtividadeExtra} onHide={() => setShowModalAtividadeExtra(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Provas extras e atividades</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <TableUsuariosProvas columns={columns} data={dataProvasExtras} titulo="Lista de provas" search={true} paging={false} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <div className="d-flex justify-content-center">
                        <button type="button" className="btn btn-outline-dark px-5 py-2" onClick={() => setShowModalAtividadeExtra(false)}>Fechar</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalAtribuirNotas} onHide={() => setShowModalAtribuirNotas(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-5 text-primary">Atribuir Notas</span>
                </Modal.Header>
                <Modal.Body className="bg-gray-100 p-4">
                    <div className="container">
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar usuário"
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                            </div>
                        </div>
                        <div className="row" style={{ maxHeight: 400, overflow: "auto" }}>
                            {filteredUsuarios.map(usuario => (
                                <div key={usuario.id} className="col-12 my-1 d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        {usuario.nome_completo}
                                    </div>
                                    <input
                                        type="number"
                                        className="form-control w-25"
                                        style={{ height: '35px' }}
                                        placeholder="Nota"
                                        value={notas[usuario.id] || ''}
                                        onChange={(e) => handleNotaChange(usuario.id, e.target.value)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn me-2" onClick={() => { setShowModalAtribuirNotas(false); setSearchTerm(null); setNotas(false) }}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={handleSubmitNotas}>Próximo</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalAlunosComNotas} onHide={() => setShowModalAlunosComNotas(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Enviar arquivo da prova</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex flex-column w-100">
                                        <div className="row" style={{ maxHeight: 400, overflow: "auto" }}>
                                            {alunosComNotas.map(usuario => (
                                                <div key={usuario.id} className="col-12 my-3 d-flex align-items-center">
                                                    <div className="flex-grow-1">
                                                        {usuario.nome_completo} <span className="badge bg-success fs-7">Nota: {notas[usuario.id]}</span>
                                                    </div>
                                                    <i className={`bi ${arquivos[usuario.id] ? 'bi-check-square-fill text-success' : 'bi-square'} me-3`}></i>
                                                    <span className="me-3" style={{ color: "rgb(185 185 185)" }}> | </span>
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <input
                                                            type="file"
                                                            id={`file-input-${usuario.id}`}
                                                            accept=".pdf,image/*"
                                                            style={{ display: 'none' }}
                                                            onChange={(e) => handleFileChange(e, usuario.id)}
                                                        />
                                                        <Tippy content="Escolher arquivo do computador">
                                                            <button
                                                                className="btn btn-primary"
                                                                onClick={() => handleUpload(usuario.id)}
                                                            >
                                                                <i className="bi bi-file-earmark-richtext"></i>
                                                            </button>
                                                        </Tippy>
                                                        <Tippy content="Tirar foto pelo celular">
                                                            <button
                                                                className="btn btn-primary d-none"
                                                                onClick={() => handleGenerateQrCode(usuario.id)}
                                                            >
                                                                <i className="bi bi-phone"></i>
                                                            </button>
                                                        </Tippy>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <div className="d-flex justify-content-center gap-2">
                        <button type="button" className="btn btn-outline-dark" onClick={() => { setShowModalAlunosComNotas(false); setShowModalAtribuirNotas(true); setTodosArquivosEnviados(false); setArquivos(false) }}>Voltar</button>
                        <button type="button" className="btn btn-primary text-white px-5 py-2" onClick={handleConcluir} disabled={!todosArquivosEnviados || loading}> {loading ? <div className="spinner-border fs-7" style={{ width: 20, height: 20, top: 2, position: 'relative' }} role="status"></div> : 'Finalizar'}</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="md" id="qrCodeModal" show={showModalQrCode} onHide={() => setShowModalQrCode(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">QR Code</span>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {qrCodeData && <QRCode value={qrCodeData} size={256} />}
                    <p className="mt-3">Escaneie este QR code para abrir o link no celular.</p>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <div className="d-flex justify-content-center gap-2">
                        <button type="button" className="btn btn-outline-dark" onClick={() => { setShowModalQrCode(false); setShowModalAlunosComNotas(true) }}>Voltar</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalFinalGrupo} onHide={() => setShowModalFinalGrupo(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Prova Final</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="h-100 bg-white rounded p-5 mt-3 text-center">
                        <div className="row">
                            <div className="col-12">
                                <i className="bi bi-check-circle text-success mb-3" style={{ fontSize: 60 }}></i>
                                <h1 className="text-success">Envios Concluidos!</h1>
                                <p className="lead mt-3">Concluido! Notas e arquivos foram enviados com sucesso.</p>
                                <Link className="btn btn-primary mt-4" onClick={() => setShowModalFinalGrupo(false)}>
                                    Voltar para a aula
                                </Link>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal para visualizar detalhes da avaliação de reação */}
            <ModalAvaliacaoReacao
                show={modalVerAvaliacaoReacao.show}
                data={modalVerAvaliacaoReacao.data}
                onHide={() => setModalVerAvaliacaoReacao({ show: false, data: null })}
            />
            {/* Modal de Criar Aula */}
            {aulasManager && aulasManager.renderModals(dataCursos)}

            {/* Drawer Mobile - Menu de Ações */}
            <Offcanvas 
                show={showDrawerMobile} 
                onHide={() => setShowDrawerMobile(false)} 
                placement="end"
                className="d-md-none"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Ações</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0">
                    <ul className="list-group list-group-flush">
                        {nivel !== 'Administrador' && (
                            (() => {
                                if (statusAvaliacao === "Fazer avaliação") {
                                    return (
                                        <li className="list-group-item">
                                            <Link 
                                                to={`/questionario/${id}`} 
                                                className="text-decoration-none d-flex align-items-center" 
                                                onClick={() => setShowDrawerMobile(false)}
                                            >
                                                <i className="bi bi-clipboard-check me-2 text-warning"></i>
                                                <span>Fazer avaliação</span>
                                            </Link>
                                        </li>
                                    );
                                } else if (statusAvaliacao === "Avaliação concluída" && avaliacaoReacaoStatus && !avaliacaoReacaoStatus.avaliacao_reacao_concluida && avaliacaoReacaoStatus.precisa_avaliacao_reacao && !avaliacaoReacaoStatus.certificado_liberado) {
                                    return (
                                        <li className="list-group-item">
                                            <Link 
                                                to={`/questionario/reacao/${id}`} 
                                                className="text-decoration-none d-flex align-items-center" 
                                                onClick={() => setShowDrawerMobile(false)}
                                            >
                                                <i className="bi bi-star me-2 text-success"></i>
                                                <span>Avaliação de Reação</span>
                                            </Link>
                                        </li>
                                    );
                                } else if (statusAvaliacao === "Avaliação concluída" && avaliacaoReacaoHibridoStatus && avaliacaoReacaoHibridoStatus.pode_responder_avaliacao_reacao_hibrido && !avaliacaoReacaoHibridoStatus.avaliacao_reacao_hibrido_concluida && !avaliacaoReacaoHibridoStatus.certificado_liberado) {
                                    return (
                                        <li className="list-group-item">
                                            <Link 
                                                to={`/questionario/reacao-hibrido/${id}`} 
                                                className="text-decoration-none d-flex align-items-center" 
                                                onClick={() => setShowDrawerMobile(false)}
                                            >
                                                <i className="bi bi-star me-2 text-success"></i>
                                                <span>Avaliação de Reação</span>
                                            </Link>
                                        </li>
                                    );
                                } else if (statusAvaliacao === "Avaliação concluída") {
                                    return null;
                                } else {
                                    return (
                                        <li className="list-group-item text-muted">
                                            <div className="d-flex align-items-center">
                                                <i className="bi bi-x-circle me-2"></i>
                                                <span>Avaliação indisponível</span>
                                            </div>
                                        </li>
                                    );
                                }
                            })()
                        )}

                        {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'RH') && (
                            <li className="list-group-item">
                                <Link 
                                    to="#" 
                                    onClick={() => {
                                        handleAtribuirNotas();
                                        setShowDrawerMobile(false);
                                    }} 
                                    className="text-decoration-none d-flex align-items-center"
                                >
                                    <i className="bi bi-people me-2 text-primary"></i>
                                    <span className="text-primary">Atribuir notas em grupo</span>
                                </Link>
                            </li>
                        )}

                        {nivel === 'Administrador' && (
                            <>
                                <li className="list-group-item">
                                    <button 
                                        onClick={() => {
                                            aulasManager && aulasManager.openAddAulaModal();
                                            setShowDrawerMobile(false);
                                        }} 
                                        className="btn btn-link text-decoration-none p-0 w-100 text-start d-flex align-items-center"
                                    >
                                        <i className="bi bi-plus-circle me-2 text-primary"></i>
                                        <span className="text-primary">Criar Aula</span>
                                    </button>
                                </li>
                                <li className="list-group-item">
                                    <Link 
                                        onClick={() => {
                                            setShowModalAvaliacao(true);
                                            setShowDrawerMobile(false);
                                        }} 
                                        className="text-decoration-none d-flex align-items-center"
                                    >
                                        <i className="bi bi-gear me-2 text-primary"></i>
                                        <span className="text-primary">Configurar Avaliação</span>
                                    </Link>
                                </li>
                            </>
                        )}

                        {(nivel === 'Administrador' || nivel === 'Gestor' || nivel === 'RH') && dataInfoModulo && dataInfoModulo[0] && (
                            <li className="list-group-item">
                                <PDFDownloadLink
                                    document={<GerarPDF data={dataInfoModulo[0].id} tipo="avaliacao_normal_visualizacao" titulo={dataInfoModulo[0].nome} />}
                                    fileName={`avaliacao_${dataInfoModulo[0].nome}.pdf`}
                                    className="text-decoration-none d-flex align-items-center"
                                >
                                    <i className="bi bi-printer me-2 text-primary"></i>
                                    <span className="text-primary">Imprimir Avaliação</span>
                                </PDFDownloadLink>
                            </li>
                        )}

                        {nivel !== 'Administrador' && (
                            <>
                                <li className="list-group-item">
                                    <Link 
                                        onClick={() => {
                                            setShowModalAtividadeExtra(true);
                                            setShowDrawerMobile(false);
                                        }} 
                                        className="text-decoration-none d-flex align-items-center"
                                    >
                                        <i className="bi bi-file-earmark-text me-2 text-primary"></i>
                                        <span className="text-primary">Atividades / Provas extras</span>
                                    </Link>
                                </li>

                                <li className="list-group-item">
                                    <div 
                                        className="text-decoration-none d-flex align-items-center cursor-pointer" 
                                        onClick={() => {
                                            setShowModalMinhasNotas(true);
                                            setShowDrawerMobile(false);
                                        }}
                                    >
                                        <i className="bi bi-journal-text me-2 text-primary"></i>
                                        <span className="text-primary">Minhas notas</span>
                                    </div>
                                </li>
                            </>
                        )}
                    </ul>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Aulas;